@if (!editMode) {
  <div>
    {{ getEmoji() }}
  </div>
} @else {
  <mat-form-field [formGroup]="formGroup" class="example-full-width">
    <input formControlName="{{ fieldConfig.name }}" matInput value="{{ data }}" />
  </mat-form-field>
}
